import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { AuthContext } from "../../auth/authContext";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import { createUser } from "../../API/ApiUsers";

import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { ReactReduxContext } from "react-redux";
import { getEstados, getMunicipios } from "../../API/ApiEstadosMunicipios";
import { DateTime } from "luxon";
import { createNewOrder } from "../../API/ApiOrdenesServicio";
import InputAdornment from "@mui/material/InputAdornment";
import { FactCheckIcon } from "@mui/icons-material/FactCheck";
import {
  agregarServicioAOrdenDeServicio,
  getServiciosOrdenesServicio,
} from "../../API/ApiServiciosOrdenesServicio";
import { nuevoPagoOrdenServicio } from "../../API/ApiPagosOrdenes";
import { agregarJardinAPanteon } from "../../API/ApiJardines";
import {
  AddEspaciosAPanteon,
  AddPanteon,
  DeleteEliminarPersonaDeEspacioAPI,
  PostAddPersonaAEspaciosAPI,
} from "../../API/ApiPanteones";
import { getAllEspacios } from "../../API/ApiEspacios";

const validationSchema = yup.object({
  idespacio: yup.string("Ingresa").required("Requerido"),
  persona: yup.string("Ingresa").required("Requerido"),
  fechaInhumacion: yup.string("Ingresa").required("Requerido"),
  fechaExhumacion: yup.string("Ingresa"),
});

export const EliminarCuerpoAEspacioComponent = (props) => {
  
  const { user, dispatch } = React.useContext(AuthContext);
  const [isDisabled, setIsDisabled] = React.useState(false);

  const [finalDataServicios, setFinalDataServicios] = React.useState([]);

  const [finalData, setFinalData] = React.useState([]);

  const [municipios, setMunicipios] = React.useState([]);

  React.useEffect(() => {
    let listo = false;

    getAllEspacios(user).then((resultado) => {
      if (resultado.status === 200) {
        setFinalData(resultado.data);
      } else {
        setFinalData([]);
      }
    });

    return () => {
      listo = true;
    };
  }, []);

  const escFunction = (event) => {
    if (event.keyCode === 27) {
      props.setCrudAction({ action: null, data: null });
    }
  };

  React.useEffect(() => {
    document.addEventListener("keydown", escFunction, false);
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, []);

  const formik = useFormik({
    initialValues: {
      idespacio: props.crudAction.data.id,
      persona: "",
      fechaInhumacion: "",
      fechaExhumacion: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (values.fechaExhumacion == "") {
        delete values.fechaExhumacion;
      }
      setIsDisabled(true);
      PostAddPersonaAEspaciosAPI(user, values).then((resultado) => {
        if (resultado.status == 200) {
          toast.success("Cuerpo Agregado correctamente");
          props.setCrudAction({ action: null, data: null });
        }
      });
    },
  });

  return (
    <>
      <div className="crudDivComponent col-md-4 px-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 my-2 mb-2">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6>Eliminar cuerpo de espacio</h6>
                </div>
                <div>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() =>
                      props.setCrudAction({ action: null, data: null })
                    }
                  >
                    <CloseIcon fontSize="inherit" />{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {isDisabled == true ? (
                <>
                  <Alert className="mb-3" severity="info">
                    Procesando información...
                  </Alert>
                </>
              ) : null}
              <hr />
            </div>
          </div>

          <div className="row">
            <div className="col">
              <div className="alert alert-danger me-2" role="alert">
                <small className="text-warning-emphasis">
                  Eliminarás el cuerpo: {props.crudAction.data.persona}
                </small>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col mt-3">
              <button
                type="submit"
                className="btn btn-sm btn-danger w-100"
                disabled={isDisabled}
                onClick={() => {
                  setIsDisabled(true);
                  DeleteEliminarPersonaDeEspacioAPI(
                    user,
                    props.crudAction.data.id
                  ).then((resultado) => {
                    if (resultado.status === 200) {
                      toast.success("Cuerpo eliminado de espacio");
                      props.setCrudAction({ action: null, data: null });
                    } else {
                      toast.error("Algo ha pasado, revisa la consola");
                      props.setCrudAction({ action: null, data: null });
                    }
                  });
                }}
              >
                Eliminar Cuerpo
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
